import {
  createReqConsts,
  createActions,
  createReqWatcher,
  makePaginationReducer,
} from '../../../utils/redux';

const requestOptions = {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'healthboard',
    'completed_tasks',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts('health-board', 'completed-tasks-req', [
  'LOAD_MORE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'health-board',
  'completed-tasks-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
  true,
);

export default makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'tasksCount',
});



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/scheduled-tasks-completed-req.js